import { render } from "./AddAssocOrder.vue?vue&type=template&id=53a1ff4a"
import script from "./AddAssocOrder.vue?vue&type=script&lang=js"
export * from "./AddAssocOrder.vue?vue&type=script&lang=js"

import "@/assets/vue-multiselect.min.css?vue&type=style&index=0&lang=css"
import "./AddAssocOrder.vue?vue&type=style&index=1&id=53a1ff4a&lang=css"

import exportComponent from "/home/runner/work/corpsales-services/corpsales-services/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__